import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { aspectRatio as ar } from "../../../../../../../../common/parameters";

import { generatePath } from "../../../../../../../paths";
import Icon from "../../../../../../../icon";

import Frame from "../../../../../Frame";
import Draggable from "../../../../../../Draggable";
import { Range } from "../../../../../../Form";

import MessageDisplay from "../../../../Common/MessageDisplay";
import { PlayBtn, Label } from "../../../../common-style";

import {
    StyledSize,
    Score,
    ScaleBar,
    ScaleBarContainer,
} from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
const margin = 40;

class Size extends Component<IProps, IState> {
    img?: HTMLImageElement;
    size?: HTMLDivElement;
    state: IState = {
        width: 0,
        height: 0,
        frameScale: 0,
        zoom: 1,
        maxScale: 1,
        scale: 1,
        sliderScale: 1,
    };

    componentDidMount() {
        this.forceUpdate();
        window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {
        setTimeout(this.imgLoaded, 100);
    };

    imgLoaded = () => {
        const { taskIndex, editTask, task } = this.props;
        const { data } = task;
        let parentAR = ar.width / ar.height;

        let cropWidth = this.img!.naturalWidth;
        let cropHeight = this.img!.naturalHeight;
        let cropAR = cropWidth / cropHeight;

        let top, left, scale, newHeight, newWidth, maxScale;
        if (parentAR > cropAR) {
            newHeight = ar.height * 0.8;
            newWidth = newHeight * cropAR;
            maxScale = (ar.height - margin) / cropHeight;
            scale = Math.min(newHeight / cropHeight);
        } else {
            newWidth = ar.width * 0.8;
            newHeight = newWidth / cropAR;
            maxScale = (ar.width - margin) / cropWidth;
            scale = Math.min(newWidth / cropWidth);
        }

        maxScale = Math.round(maxScale * 100) / 100;
        scale = Math.round(scale * 100) / 100;

        top = (ar.height - newHeight) / 2;
        left = (ar.width - newWidth) / 2;
        if (data.scorePosition) {
            top = data.scorePosition.top;
            left = data.scorePosition.left;
            scale = data.scale;
        } else {
            let scorePosition = {
                top,
                left,
            };
            editTask({ taskIndex, changingProp: "scorePosition", val: scorePosition });
            editTask({ taskIndex, changingProp: "scale", val: scale });
            setTimeout(this.save, 100);
        }
        let frameWidth = this.img!.parentElement!.parentElement!.parentElement!.getBoundingClientRect().width;
        let frameScale = frameWidth / ar.width;

        let sliderScale = this.size!.parentElement!.parentElement!.getBoundingClientRect().width / 1280;

        this.setState({
            width: this.img!.naturalWidth,
            height: this.img!.naturalHeight,
            frameScale,
            maxScale,
            sliderScale,
        });
    };

    changePosition = (left: number, top: number) => {
        const { width, height } = this.state;
        const { taskIndex, editTask, task } = this.props;
        const {
            data: { scale },
        } = task;
        if (left + width * scale! > ar.width) {
            left = ar.width - width * scale!;
        }
        if (top + height * scale! > ar.height) {
            top = ar.height - height * scale!;
        }

        left = Math.ceil(left);
        top = Math.ceil(top);

        let scorePosition = {
            top,
            left,
        };
        editTask({ taskIndex, changingProp: "scorePosition", val: scorePosition });
    };

    changeScale = (scale: number) => {
        // let scale = (dragLeft * this.state.maxScale + 80) / 200;
        // if (scale > this.state.maxScale) scale = this.state.maxScale;
        // scale = Math.ceil(scale * 100) / 100;
        const { task, editTask, taskIndex } = this.props;
        const originalScale = task.data.scale;

        let {
            data: { scorePosition },
        } = task;

        let { top, left } = scorePosition!;
        const { width, height } = this.state;
        let scaleChange = originalScale! - scale;
        left += (scaleChange * width) / 2;
        top += (scaleChange * height) / 2;
        if (left + width * scale > ar.width - margin * 2) {
            left = ar.width - margin * 2 - width * scale;
        }
        if (top + height * scale > ar.height - margin * 2) {
            top = ar.height - margin * 2 - height * scale;
        }
        if (top < 0) top = 0;
        if (left < 0) left = 0;
        left = Math.ceil(left);
        top = Math.ceil(top);
        this.setState({ scale });

        scorePosition = {
            top,
            left,
        };
        editTask({ taskIndex, changingProp: "scorePosition", val: scorePosition });
        editTask({ taskIndex, changingProp: "scale", val: scale });
    };

    save = () => {
        const { plan, taskIndex, post, task } = this.props;
        const { scorePosition, scale } = task.data;
        post("score-editor-size", {
            planId: plan._id,
            index: taskIndex,
            scorePosition,
            scale,
        });
    };

    render() {
        const { task: { data: { score, scorePosition, scale } } } = this.props;
        let { top, left } = scorePosition || {};
        const { width, height, frameScale, maxScale, sliderScale } = this.state;
        return (
            <StyledSize ref={size => (this.size = size!)}>
                {this.size !== undefined && (
                    <Frame parent={this.size} fixed>
                        <Draggable
                            position={{
                                x: left!,
                                y: top!,
                            }}
                            scale={frameScale}
                            onDrag={(left, top) => this.changePosition(Math.ceil(left), Math.ceil(top))}
                            onStop={this.save}
                        >
                            <Score
                                style={{
                                    transform: `scale(${scale}, ${scale})`,
                                }}
                            >
                                <img
                                    src={generatePath(score!)}
                                    ref={img => (this.img = img!)}
                                    onLoad={this.imgLoaded}
                                    width={width}
                                    height={height}
                                    alt="score"
                                />
                            </Score>
                        </Draggable>
                        <PlayBtn className={cn("button", "button--play")} disabled>
                            <Icon i="play" />
                            <Label>
                                <FormattedMessage {...messages.play} />
                            </Label>
                        </PlayBtn>
                        <MessageDisplay type="editor" isLow={false}/>
                    </Frame>
                )}
                <ScaleBar>
                    <ScaleBarContainer>
                        <Range
                            scale={sliderScale}
                            value={scale || 1}
                            min={0.3}
                            max={maxScale || 2}
                            step={0.01}
                            onChange={this.changeScale}
                            onStop={this.save}
                        />
                    </ScaleBarContainer>
                </ScaleBar>
            </StyledSize>
        );
    }
}

export default Size;
